export default __webpack_public_path__ + "static/media/25_photo.f8c04cf1.jpg";